import {VueMaskDirective} from "v-mask";
import IPlugin from "./plugin";

export default class VueMaskPlugin extends IPlugin {
    setup(Vue, config) {
        Vue.directive('mask', VueMaskDirective);
        return super.setup(Vue, config);
    }
}